<div ngModelGroup="comboUf-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboUf
                       nome="uf-{{data}}"
                       [itens]="dados"
                       itemDescricao="nome"
                       itemId="nome"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="UF"
                       label="UF"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
